import {
	getRecentSearches,
	RECENT_SEARCH_KEY,
	getRecentQueryObject,
	type RecentSearchItem,
	type RecentSearchObject,
} from '@atlassian/search-common/recent-searches';

import { type PrimaryProductKey } from '../../../../common/constants/products';

export const getRecentQueries = (
	primaryProduct: PrimaryProductKey,
	userId: string,
): {
	id: string;
	title: string;
	data: RecentSearchObject;
	type: 'recent-query';
}[] => {
	const recentSearches = getRecentSearches({
		userId,
		productId: primaryProduct,
		key: RECENT_SEARCH_KEY,
	});
	return recentSearches.map(mapEssentialData);
};

export const mapEssentialData = (
	value: RecentSearchItem,
): {
	id: string;
	title: string;
	data: RecentSearchObject;
	type: 'recent-query';
} => {
	const data = getRecentQueryObject(value);
	return {
		id: data.query,
		title: data.query,
		data,
		type: 'recent-query' as const,
	};
};
